// Mock data for W Shoot - Automotive Photography Website

export const heroImage = "https://customer-assets.emergentagent.com/job_supercar-lens/artifacts/0se6dly4_image.png";

export const carBrands = [
  {
    id: 1,
    name: "Ferrari",
    images: [
      "https://images.unsplash.com/photo-1610847499832-918a1c3c6811",
      "https://images.unsplash.com/photo-1617654112368-307921291f42",
      "https://images.unsplash.com/photo-1592198084033-aade902d1aae",
      "https://images.unsplash.com/photo-1583121274602-3e2820c69888",
      "https://images.unsplash.com/photo-1503736334956-4c8f8e92946d"
    ]
  },
  {
    id: 2,
    name: "Lamborghini",
    images: [
      "https://images.unsplash.com/photo-1511919884226-fd3cad34687c",
      "https://images.unsplash.com/photo-1519245659620-e859806a8d3b",
      "https://images.unsplash.com/photo-1630312465536-5c6b1f76dc3f",
      "https://images.unsplash.com/photo-1570294646112-27ce4f174e38",
      "https://images.unsplash.com/photo-1566024164372-0281f1133aa6"
    ]
  },
  {
    id: 3,
    name: "Porsche",
    images: [
      "https://images.unsplash.com/photo-1611651338412-8403fa6e3599",
      "https://images.unsplash.com/photo-1580274455191-1c62238fa333",
      "https://images.unsplash.com/photo-1614162692292-7ac56d7f7f1e",
      "https://images.unsplash.com/photo-1614244788272-f6dcdfd8df9f",
      "https://images.unsplash.com/photo-1617814086906-d847a8bc6fca"
    ]
  },
  {
    id: 4,
    name: "Mercedes-Benz",
    images: [
      "https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8",
      "https://images.unsplash.com/photo-1609521263047-f8f205293f24",
      "https://images.unsplash.com/photo-1617654112368-307921291f42",
      "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6",
      "https://images.unsplash.com/photo-1563720223185-11003d516935"
    ]
  },
  {
    id: 5,
    name: "BMW",
    images: [
      "https://images.unsplash.com/photo-1555215695-3004980ad54e",
      "https://images.unsplash.com/photo-1617814076367-b759c7d7e738",
      "https://images.unsplash.com/photo-1607853202273-797f1c22a38e",
      "https://images.unsplash.com/photo-1617531653332-bd46c24f2068",
      "https://images.unsplash.com/photo-1606220588913-b3aacb4d2f46"
    ]
  },
  {
    id: 6,
    name: "Audi",
    images: [
      "https://images.unsplash.com/photo-1564544422008-d0fb0c42c010",
      "https://images.unsplash.com/photo-1692098861062-e6b4b4ec96bc",
      "https://images.unsplash.com/photo-1653609956301-21016f9de75b",
      "https://images.unsplash.com/photo-1660153761715-c4ff5bf872d3",
      "https://images.unsplash.com/photo-1606220588913-b3aacb4d2f46"
    ]
  },
  {
    id: 7,
    name: "Aston Martin",
    images: [
      "https://images.unsplash.com/photo-1614200187524-dc4b892acf16",
      "https://images.unsplash.com/photo-1563720223185-11003d516935",
      "https://images.unsplash.com/photo-1552519507-da3b142c6e3d",
      "https://images.unsplash.com/photo-1581540222194-0def2dda95b8",
      "https://images.unsplash.com/photo-1567818735868-e71b99932e29"
    ]
  },
  {
    id: 8,
    name: "McLaren",
    images: [
      "https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7",
      "https://images.unsplash.com/photo-1626668893632-6f3a4466d22f",
      "https://images.unsplash.com/photo-1621839673705-6617adf9e890",
      "https://images.unsplash.com/photo-1544636331-e26879cd4d9b",
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64"
    ]
  },
  {
    id: 9,
    name: "Lotus",
    images: [
      "https://images.unsplash.com/photo-1708019871570-c885bd96da08",
      "https://images.unsplash.com/photo-1708019826122-33b9fc8d6d57",
      "https://images.unsplash.com/photo-1728484117030-bd27b37a1577",
      "https://images.unsplash.com/photo-1704184474275-a6770fa7513e",
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64"
    ]
  },
  {
    id: 10,
    name: "Jaguar",
    images: [
      "https://images.unsplash.com/photo-1603584173870-7f23fdae1b7a",
      "https://images.unsplash.com/photo-1621135802920-1597560fdee5",
      "https://images.unsplash.com/photo-1563720223185-11003d516935",
      "https://images.unsplash.com/photo-1552519507-da3b142c6e3d",
      "https://images.unsplash.com/photo-1581540222194-0def2dda95b8"
    ]
  },
  {
    id: 11,
    name: "Lexus",
    images: [
      "https://images.unsplash.com/photo-1628188765472-50896231dafb",
      "https://images.unsplash.com/photo-1763569731289-eb46444a9ba3",
      "https://images.unsplash.com/photo-1771556907904-073e16b61983",
      "https://images.unsplash.com/photo-1763067215343-9c6011c49a6f",
      "https://images.unsplash.com/photo-1563720223185-11003d516935"
    ]
  },
  {
    id: 12,
    name: "Renault",
    images: [
      "https://images.unsplash.com/photo-1656724997599-0c551228da85",
      "https://images.unsplash.com/photo-1656724996989-f2396fe87c17",
      "https://images.unsplash.com/photo-1766461055869-822151e3ed37",
      "https://images.unsplash.com/photo-1579462127229-b42e9ca0eddf",
      "https://images.pexels.com/photos/6747188/pexels-photo-6747188.jpeg"
    ]
  },
  {
    id: 13,
    name: "Volkswagen",
    images: [
      "https://images.unsplash.com/photo-1630245504306-9d8fe0e35714",
      "https://images.unsplash.com/photo-1579632005973-bdef2ee231a5",
      "https://images.unsplash.com/photo-1618677912087-6b942ef01b6f",
      "https://images.unsplash.com/photo-1655285162488-f495df383244",
      "https://images.unsplash.com/photo-1579632005973-bdef2ee231a5"
    ]
  }
];

export const partnerLogos = [
  {
    id: 1,
    name: "Les Mordus d'AutoMoto",
    logo: "https://customer-assets.emergentagent.com/job_supercar-lens/artifacts/xi5ea4bc_1F779F6A-2034-44EB-960A-3CF40D3805DC.PNG",
    description: "Club automobile et moto"
  },
  {
    id: 2,
    name: "Graphic Protect",
    logo: "https://customer-assets.emergentagent.com/job_supercar-lens/artifacts/ry2iawjr_12295494-6DE8-4E42-8F8B-095A613E48AC.PNG",
    description: "Covering PPF - Vitres teintées"
  },
  {
    id: 3,
    name: "Net Car Lannion",
    logo: "https://customer-assets.emergentagent.com/job_supercar-lens/artifacts/doebkdkq_37216443-3712-4C63-8A2D-B24E8133D546.PNG",
    description: "Detailing automobile"
  },
  {
    id: 4,
    name: "FLO Motorsport",
    logo: "https://customer-assets.emergentagent.com/job_supercar-lens/artifacts/wxr0vjgh_A6D6973E-D884-424B-A4DD-8C4982063D6A.PNG",
    description: "Préparation et motorsport"
  },
  {
    id: 5,
    name: "Breizh Cars Club",
    logo: "https://customer-assets.emergentagent.com/job_supercar-lens/artifacts/84sg6dtf_B753C351-D312-4934-A385-B8B15C0E8E94.PNG",
    description: "Club automobile Bretagne"
  }
];

export const shootingTypes = [
  {
    id: 1,
    title: "Shooting Voiture Particulier",
    description: "Mettez en valeur votre véhicule avec une séance photo professionnelle sur mesure.",
    icon: "Car"
  },
  {
    id: 2,
    title: "Shooting Supercar",
    description: "Photos cinématiques pour supercars et véhicules d'exception avec éclairage dramatique.",
    icon: "Zap"
  },
  {
    id: 3,
    title: "Shooting Moto",
    description: "Capturez la puissance et les lignes de votre moto avec style.",
    icon: "Bike"
  },
  {
    id: 4,
    title: "Shooting Concession",
    description: "Photos professionnelles pour concessions et showrooms automobiles.",
    icon: "Building"
  },
  {
    id: 5,
    title: "Shooting Événement",
    description: "Couverture photographique complète de rassemblements et événements automobiles.",
    icon: "Calendar"
  },
  {
    id: 6,
    title: "Photos pour Vente",
    description: "Valorisez votre véhicule avec des photos qui feront la différence.",
    icon: "Camera"
  }
];

export const socialLinks = {
  instagram: "https://www.instagram.com/w_shoot_22/",
  instagramUsername: "w_shoot_22"
};
